jQuery(document).ready(function() {
	// load slider for Headslider
	jQuery('#mainslider').slick({
	  dots: false,
	  infinite: true,
	  speed: 1000,
	  slidesToShow: 4,
	  variableWidth: true,
	  autoplay: true,
	  autoplaySpeed: 2000,	 
	  centerMode: true
	});

    jQuery('.galleriewrap.slider').slick({
        slidesToShow: 3,
        swipeToSlide: true,
        arrows: true,
        variableWidth: true,
        infinite: true
    });



    jQuery('.produktslider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
      {
          breakpoint: 1624,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
          }
      },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


    if(window.innerWidth < 900) {
        mobileOnlySlider();
    }



jQuery('.postslider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1124,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

	jQuery("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 466 841.9'><defs><rect x='21' y='13.9' width='429' height='813.6'/></defs><clipPath><use xlink:href='#SVGID_1_'/></clipPath><path d='M443 403.6L60.2 20.9c-9-9-23.5-9-32.5 0 -9 9-9 23.5 0 32.5l366.4 366.4L27.8 786.2c-9 9-9 23.5 0 32.5 4.4 4.4 10.4 6.8 16.2 6.8 5.8 0 11.7-2.2 16.1-6.8l382.8-382.7C451.8 427.1 451.8 412.5 443 403.6L443 403.6zM443 403.6' clip-path='url(#SVGID_2_)'/></svg>").appendTo( ".slick-next , .slick-prev");


});

jQuery(window).resize(function(e){
    if(window.innerWidth < 900) {
        if(!jQuery('.iconfield').hasClass('slick-initialized')){
            mobileOnlySlider();
            console.log('here');
        }
    }else{
        if(jQuery('.iconfield').hasClass('slick-initialized')){
            jQuery('.iconfield').slick('unslick');
            console.log('nowhere') ;
        }
    }
});

function mobileOnlySlider() {
    jQuery('.iconfield').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    unslick: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    unslick: false
                }
            }
        ]
    });
}
